import React from 'react';
import { useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isQuiz = location.pathname === '/quiz';

  return (
    <nav className="main-nav">
      <a href="/" className={`nav-link ${isHome ? 'active' : ''}`}>Home</a>
      <a href="/quiz" className={`nav-link ${isQuiz ? 'active' : ''}`}>Word Quiz</a>
    </nav>
  );
};

export default Navigation;